import type {QRVCardInput} from '@Libraries/qr-code/qr-code.types';
import {QRPayloadField} from '@Libraries/qr-code/qr-code.types';
import type {QRFormProps} from '@Components/qr-code-generator/qr-code-generator.types';

export type QRVCardFormProps = QRFormProps<QRVCardInput>;

export interface QRVCardFieldSpec {
  inputKey: keyof QRVCardInput;
  labelKey: string;
  placeholderKey: string;
  field?: QRPayloadField;
}

export const QR_VCARD_CONTACT_ROWS: QRVCardFieldSpec[][] = [
  [
    {
      inputKey: 'firstName',
      labelKey: 'pmwjs_qr_generator_vcard_first_name_label',
      placeholderKey: 'pmwjs_qr_generator_vcard_first_name_placeholder',
      field: QRPayloadField.FIRST_NAME,
    },
    {inputKey: 'lastName', labelKey: 'pmwjs_qr_generator_vcard_last_name_label', placeholderKey: 'pmwjs_qr_generator_vcard_last_name_placeholder', field: QRPayloadField.LAST_NAME},
  ],
  [
    {inputKey: 'organisation', labelKey: 'pmwjs_qr_generator_vcard_organisation_label', placeholderKey: 'pmwjs_qr_generator_vcard_organisation_placeholder'},
    {inputKey: 'jobTitle', labelKey: 'pmwjs_qr_generator_vcard_job_title_label', placeholderKey: 'pmwjs_qr_generator_vcard_job_title_placeholder'},
  ],
  [
    {inputKey: 'mobileNumber', labelKey: 'pmwjs_qr_generator_vcard_mobile_label', placeholderKey: 'pmwjs_qr_generator_vcard_mobile_placeholder'},
    {inputKey: 'workNumber', labelKey: 'pmwjs_qr_generator_vcard_work_label', placeholderKey: 'pmwjs_qr_generator_vcard_work_placeholder'},
  ],
  [
    {inputKey: 'emailAddress', labelKey: 'pmwjs_qr_generator_vcard_email_label', placeholderKey: 'pmwjs_qr_generator_vcard_email_placeholder'},
    {inputKey: 'website', labelKey: 'pmwjs_qr_generator_vcard_website_label', placeholderKey: 'pmwjs_qr_generator_vcard_website_placeholder'},
  ],
  [{inputKey: 'faxNumber', labelKey: 'pmwjs_qr_generator_vcard_fax_label', placeholderKey: 'pmwjs_qr_generator_vcard_fax_placeholder'}],
];

export const QR_VCARD_ADDRESS_ROWS: QRVCardFieldSpec[][] = [
  [
    {inputKey: 'street', labelKey: 'pmwjs_qr_generator_vcard_street_label', placeholderKey: 'pmwjs_qr_generator_vcard_street_placeholder'},
    {inputKey: 'city', labelKey: 'pmwjs_qr_generator_vcard_city_label', placeholderKey: 'pmwjs_qr_generator_vcard_city_placeholder'},
  ],
  [
    {inputKey: 'region', labelKey: 'pmwjs_qr_generator_vcard_region_label', placeholderKey: 'pmwjs_qr_generator_vcard_region_placeholder'},
    {inputKey: 'postalCode', labelKey: 'pmwjs_qr_generator_vcard_postal_code_label', placeholderKey: 'pmwjs_qr_generator_vcard_postal_code_placeholder'},
  ],
  [{inputKey: 'country', labelKey: 'pmwjs_qr_generator_vcard_country_label', placeholderKey: 'pmwjs_qr_generator_vcard_country_placeholder'}],
];
